import { render, staticRenderFns } from "./OfferListNew.vue?vue&type=template&id=14a176b0&"
import script from "./OfferListNew.vue?vue&type=script&lang=js&"
export * from "./OfferListNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('14a176b0', component.options)
    } else {
      api.reload('14a176b0', component.options)
    }
    module.hot.accept("./OfferListNew.vue?vue&type=template&id=14a176b0&", function () {
      api.rerender('14a176b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/OfferListNew.vue"
export default component.exports